import {
    FURUI_CHOOSE_CURRENT_FRUI_PLAN,
} from './constants';
  
export function chooseCurrentFrui_plan(modal) {
    return {
      type: FURUI_CHOOSE_CURRENT_FRUI_PLAN,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case FURUI_CHOOSE_CURRENT_FRUI_PLAN:
        return {
          ...state,
          currentFrui_plan:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/furui/redux/chooseCurrentFrui_plan.js